class CartCheckboxUpsell {
  constructor(cartItemsInstance) {
    this.cartItemsInstance = cartItemsInstance;
    this.baseUrl = '/cart';
    this.checkboxUpsellVariantId = this.getUpsellCheckboxVariantId();
    this.initEventDelegation();
    document.addEventListener('cartUpdated', this.handleCartUpdate.bind(this));
    this.updateCheckboxState();

    // Monitor cart drawer events to refresh checkbox state
    this.initCartDrawerListener();
  }

  initEventDelegation() {
    document.body.addEventListener('change', (event) => {
      if (event.target.id === 'cart-upsell-checkbox') {
        const isChecked = event.target.checked;
        console.log('Upsell checkbox state changed:', isChecked);

        if (isChecked) {
          this.addUpsellCheckboxToCart();
        } else {
          this.removeUpsellCheckboxFromCart();
        }
      }
    });
  }

  initCartDrawerListener() {
    const cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer) {
      const observer = new MutationObserver(() => {
        console.log('Cart drawer content changed. Updating checkbox state.');
        this.updateCheckboxState();
        this.removeUpsellIfCartIsEmpty(); // Check if only upsell remains
      });

      observer.observe(cartDrawer, {
        childList: true,
        subtree: true,
      });
    }
  }

  getUpsellCheckboxVariantId() {
    return document.querySelector('#cart-upsell-checkbox')?.getAttribute('data-variant-id');
  }

  updateCheckboxState() {
    fetch(`${this.baseUrl}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const hasUpsellCheckbox = cart.items.some(
          (item) => item.variant_id.toString() === this.checkboxUpsellVariantId
        );
        const checkboxUpsellCheckbox = document.querySelector('#cart-upsell-checkbox');
        if (checkboxUpsellCheckbox) {
          checkboxUpsellCheckbox.checked = hasUpsellCheckbox;
          console.log('Checkbox state updated:', hasUpsellCheckbox);
        }
      })
      .catch((error) => {
        console.error('Error fetching cart:', error);
      });
  }

  handleCartUpdate() {
    console.log('Cart updated event received.');
    this.updateCheckboxState();
    this.removeUpsellIfCartIsEmpty();
    this.onCartUpdateCheckboxUpsell();
  }

  addUpsellCheckboxToCart() {
    const formData = new FormData();
    formData.append('id', this.checkboxUpsellVariantId);
    formData.append('quantity', 1);

    fetch(`${this.baseUrl}/add.js`, {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        if (response.ok) {
          if (this.cartItemsInstance && typeof this.cartItemsInstance.onCartUpdate === 'function') {
            this.cartItemsInstance.onCartUpdate();
          }
          this.onCartUpdateCheckboxUpsell();
        }
        return response.json();
      })
      .catch((error) => {
        console.error('Error adding cart upsell:', error);
      });
  }

  removeUpsellCheckboxFromCart() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const lineItemIndex = cart.items.findIndex(
          (item) => item.variant_id.toString() === this.checkboxUpsellVariantId
        );
        if (lineItemIndex !== -1) {
          const line = lineItemIndex + 1;
          console.log('Removing upsell product from cart, line:', line);
          this.cartItemsInstance.updateQuantity(line, 0, null, () => {
            this.handleCartUpdate();
          });
        } else {
          console.error('Cart upsell product not found in cart.');
        }
      })
      .catch((error) => {
        console.error('Error fetching cart for cart upsell removal:', error);
      });
  }

  removeUpsellIfCartIsEmpty() {
    fetch(`${this.baseUrl}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const totalItems = cart.items.length;
        const isOnlyUpsell =
          totalItems === 1 &&
          cart.items[0].variant_id.toString() === this.checkboxUpsellVariantId;

        if (isOnlyUpsell) {
          console.log('Cart is empty except for upsell. Removing upsell.');
          this.removeUpsellCheckboxFromCart();
        }
      })
      .catch((error) => console.error('Error checking if cart is empty:', error));
  }

  getSectionsToRenderCheckboxUpsell() {
    const mainCartFooter = document.getElementById('main-cart-footer');
    const cartDrawer = document.getElementById('CartDrawer');
    const sections = [
      ...(cartDrawer
        ? [
            {
              id: 'CartDrawer',
              section: 'cart-drawer',
              selector: '#CartDrawer .js-contents',
            },
          ]
        : []),
      ...(mainCartFooter
        ? [
            {
              id: 'main-cart-footer',
              section: mainCartFooter.dataset.id,
              selector: '#main-cart-footer .js-contents',
            },
          ]
        : []),
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      },
    ];
    console.log('Sections to render:', sections);
    return sections;
  }

  onCartUpdateCheckboxUpsell() {
    console.log('Updating cart sections...');
    this.getSectionsToRenderCheckboxUpsell().forEach((section) => {
      fetch(`${routes.cart_url}?section_id=${section.section}`)
        .then((response) => response.text())
        .then((html) => {
          const container = document.querySelector(section.selector);
          if (!container) {
            console.error(`Container not found for selector: ${section.selector}`);
            return;
          }
          console.log(`Updating section ${section.id}`);
          if (section.id === 'CartDrawer') {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const jsContents = doc.querySelector('.js-contents');
            if (jsContents) {
              container.innerHTML = jsContents.innerHTML;
            } else {
              console.error(`.js-contents not found in fetched HTML for section: ${section.id}`);
            }
          } else {
            container.innerHTML = html;
          }
        })
        .catch((error) => console.error(`Error updating section ${section.id}:`, error));
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const cartItemsInstance = document.querySelector('cart-items');
  const cartDrawerItemsInstance = document.querySelector('cart-drawer-items');
  const activeCartInstance = cartDrawerItemsInstance || cartItemsInstance;

  if (activeCartInstance) {
    new CartCheckboxUpsell(activeCartInstance);
  } else {
    console.log('Neither cart-items nor cart-drawer-items found in the DOM.');
  }
});
